import axios from "@/hooks/axios/axios";
import type { IContactRequest, IContactResponse } from "../types/contact.types";

export const sendContactRequest = async (
  payload: IContactRequest,
): Promise<IContactResponse> => {
  const { data } = await axios.post<IContactResponse>("/contact", payload);
  return data;
};
